<template>
    <div class="case_card">
        <div class="caseInfo cardBgc">
            <div class="btnGroups">
                <el-button type="primary" size="mini" @click="goBack">返回</el-button>
            </div>
            <!-- 案件风险 -->
            <div class="card_title fold_title noneTopMargin">
                <i :class="isFold1 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold1 = !isFold1"></i>
                <span>案件风险</span>
                <div :class="['title_hot', riskNumData.color]" v-if="riskNumData.num > 0 && 0">案件风险：{{ riskNumData.num }}个</div>
            </div>
            <div class="card_content card_risk" v-if="isFold1">
                <div class="case_risk" v-if="caseRiskVos && caseRiskVos[0] && (caseRiskVos[0].highCount > 0 || caseRiskVos[0].lowCount > 0)">
                    <template v-for="(items, index) in caseRiskVos">
                        <el-row class="case_risk_collapse risk_hot" :key="index">
                            <el-col class="risk_col errorColor" :span="7" v-if="items.highCount > 0">
                                <div class="risk_icon errorColor">高</div>
                                高风险点：{{ items.highCount ? items.highCount : '0' }}个
                            </el-col>
                            <el-col class="risk_col warningColor" :span="7" :offset="1" v-if="0">
                                <div class="risk_icon warningColor">中</div>
                                中风险点：{{ items.mediumCount ? items.mediumCount : '0' }}个
                            </el-col>
                            <el-col class="risk_col successColor" :span="7" :offset="1" v-if="items.lowCount > 0">
                                <div class="risk_icon successColor">低</div>
                                低风险点：{{ items.lowCount ? items.lowCount : '0' }}个
                            </el-col>
                        </el-row>

                        <el-row class="risk_row" :key="index + 10086">
                            <!-- 高风险 -->
                            <el-col class="risk_col" :span="7">
                                <div class="content_row errorColor" v-for="(oItem, oIndex) in items.highRiskInfos" :key="oIndex">
                                    <el-row class="risk_info">
                                        <el-col>
                                            <!-- 弹窗展示图片 -->
                                            <!-- @click="showRiskPreviewDialog(0, items.highRiskInfos, oItem, oIndex)" -->
                                            <div class="risk_content">
                                                <!-- <span>{{ oItem.name }}</span> -->
                                                <overflow-txt :txt="oItem.name"></overflow-txt>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                            <!-- 中风险 -->
                            <el-col class="risk_col" :span="7" :offset="1" v-if="0">
                                <div class="content_row warningColor" v-for="(mediumItem, mediumIndex) in items.mediumRiskInfos" :key="mediumIndex">
                                    <el-row class="risk_info">
                                        <el-col>
                                            <!-- <div class="risk_content risk_active" @click="showRiskPreviewDialog(1, items.mediumRiskInfos, mediumItem, mediumIndex)">
                                            <overflow-txt :txt="mediumItem.name"></overflow-txt>
                                        </div> -->

                                            <div class="risk_content">
                                                <overflow-txt :txt="mediumItem.name"></overflow-txt>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                            <!-- 低风险 -->
                            <el-col class="risk_col" :span="8" :offset="1">
                                <div class="content_row successColor" v-for="(lowItem, lowIndex) in items.lowRiskInfos" :key="lowIndex">
                                    <el-row class="risk_info">
                                        <el-col>
                                            <!-- <div class="risk_content risk_active" @click="showRiskPreviewDialog(2, items.lowRiskInfos, lowItem, lowIndex)">
                                            <overflow-txt :txt="lowItem.name"></overflow-txt>
                                        </div> -->
                                            <div class="risk_content">
                                                <overflow-txt :txt="lowItem.name"></overflow-txt>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
                <p v-else class="noneData">暂未发现已知风险点</p>
            </div>
            <!-- 案件信息 -->
            <div class="card_title fold_title">
                <i :class="isFold2 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold2 = !isFold2"></i>
                <span>案件信息</span>
            </div>
            <div class="card_content text_columns clearfix" v-if="isFold2">
                <el-row>
                    <el-col :span="10" :offset="1">
                        <el-row class="txt_row">
                            <el-col class="left_col" :span="showPopup ? 3 : 5">
                                <div class="txtRight card-col_title">报案号：</div>
                            </el-col>
                            <el-col class="right_col rightBgc" :span="17">
                                <overflow-txt :txt="caseDetail.caseNo"></overflow-txt>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="casePlateNo cardBgc">
            <el-tabs v-model="activeName" @tab-click="plateNoClick">
                <el-tab-pane v-for="(item, index) in repairList" :key="index" :label="item.plateNo" :name="item.plateNo"></el-tab-pane>
            </el-tabs>
            <!-- 换件列表 -->
            <div class="card_title fold_title noneMarginTop">
                <i :class="isFold3 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold3_1 = !isFold3_1"></i>
                <span>换件列表</span>
            </div>
            <div class="card_content" v-if="isFold3_1">
                <template v-if="repairList && repairList.length > 0">
                    <el-table :data="replacePartsData" max-height="350">
                        <el-table-column prop="partName" label="零部件名称"> </el-table-column>
                        <el-table-column prop="lossAuditResidualValue" label="扣减"> </el-table-column>
                        <el-table-column prop="auditQuotationAmount" label="损失金额"> </el-table-column>
                        <el-table-column prop="cancelRecycleReasonDesc" label="取消回收原因"> </el-table-column>
                    </el-table>
                </template>
                <p v-else class="noneData">暂无数据</p>
            </div>
            <!-- 外修列表 -->
            <div class="card_title fold_title">
                <i :class="isFold3 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold3 = !isFold3"></i>
                <span>外修列表</span>
            </div>
            <div class="card_content" v-if="isFold3">
                <template v-if="repairList && repairList.length > 0">
                    <el-table :data="tableData" max-height="350">
                        <el-table-column prop="repairName" label="零配件名称"> </el-table-column>
                        <el-table-column prop="repairNumber" label="零配件编号"> </el-table-column>
                        <el-table-column prop="repairType" label="零件材料类型"> </el-table-column>
                        <el-table-column prop="specialRepairName" label="专修商"> </el-table-column>
                        <el-table-column prop="repairNum" label="数量"> </el-table-column>
                        <el-table-column prop="repairPrice" label="估损单价（元）"> </el-table-column>
                    </el-table>
                </template>
                <p v-else class="noneData">暂无数据</p>
            </div>
            <!-- 案件材料 -->
            <div class="card_title fold_title">
                <i :class="isFold4 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold4 = !isFold4"></i>
                <span>案件材料</span>
            </div>
            <div class="card_content materialBox clearfix" v-if="isFold4">
                <template v-if="treeData && treeData.length > 0">
                    <div class="material_left fl">
                        <el-tree :data="treeData" :props="defaultProps" highlight-current @node-click="handleNodeClick"></el-tree>
                    </div>
                    <div class="material_right fr">
                        <template v-if="materialList && materialList.length > 0">
                            <!-- 案件材料 -->
                            <div class="card_types autoP">
                                <ul class="clearfix">
                                    <template v-for="(item, index) in materialList">
                                        <li :class="index === liActiveIndex ? 'li_activeBorder card_type fl' : 'card_type fl'" :key="index" @click="switchCarousel(item, index)">
                                            <div v-if="item[0]">
                                                <span>{{ item.length }}</span>
                                                <p>{{ item[0].fileSubType.slice(0, 5) }}</p>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <!-- 轮播图 -->
                            <div class="preview_parent" v-if="imgUrlList && imgUrlList.length > 0">
                                <i :class="showPopup ? 'showLeft left-btn el-icon-arrow-left' : 'left-btn el-icon-arrow-left'" @click="imgLeft()"></i>
                                <i :class="showPopup ? 'showRight right-btn el-icon-arrow-right' : 'right-btn el-icon-arrow-right'" @click="imgRight()"></i>
                                <div :class="showPopup ? 'showPreview preview-box' : 'preview-box'" v-if="imgUrlList.length > 0">
                                    <ul class="Img_ul">
                                        <template v-for="(item, index) in imgUrlList">
                                            <li class="Img_li" :style="imgStyle" :key="index">
                                                <el-image :class="index === imgActiveIndex ? 'img_activeBorder' : ''" style="width: 100%; height: 100%" :src="item.fileUrl" :preview-src-list="[item.fileUrl]"> </el-image>
                                                <!-- <img :class="i === imgActiveIndex ? 'img_activeBorder' : ''" :src="item" @click="previewImg(item, i)" /> -->
                                                <!-- 图片样式 -->
                                                <!-- <template v-if="item.isImg && item.url">
                                        <img :class="i === imgActiveIndex ? 'img_activeBorder' : ''" :src="item" @click="previewImg(item, i)" />
                                    </template> -->
                                                <!-- 非图片后缀样式 -->
                                                <!-- <template v-else-if="item.url">
                                        <div :class="i === imgActiveIndex ? 'img_activeBorder img_none' : 'img_none'" @click="previewImg(item, i)">
                                            <p style="margin: 4px 0">{{ item.suffix }}</p>
                                            <p>!&nbsp;非图片文件</p>
                                            <p style="margin-top: 5px">无法展示</p>
                                        </div>
                                    </template> -->
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </template>
                        <el-empty v-else></el-empty>
                    </div>
                </template>
                <p v-else class="noneData">暂无数据</p>
            </div>
        </div>
        <div class="caseBottom cardBgc">
            <!-- 赔付账户 -->
            <div class="card_title fold_title">
                <i :class="isFold5 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold6 = !isFold6"></i>
                <span>赔付账户</span>
            </div>
            <div class="card_content" v-if="isFold6">
                <template v-if="accountTableData && accountTableData.length > 0">
                    <el-table :data="accountTableData" max-height="350">
                        <el-table-column prop="payeeTypeDesc" label="收款人类别"> </el-table-column>
                        <el-table-column prop="payeeAccountName" label="收款人户名"> </el-table-column>
                        <el-table-column prop="paymentAmount" label="支付金额"> </el-table-column>
                        <el-table-column prop="exceptionalReasonDesc" label="例外原因"> </el-table-column>
                        <el-table-column prop="exceptionalReasonMemo" label="例外原因说明"> </el-table-column>
                        <el-table-column prop="memo" label="备注"> </el-table-column>
                    </el-table>
                </template>
                <p v-else class="noneData">暂无数据</p>
            </div>
            <!-- 质检结论 -->
            <div class="card_title fold_title">
                <i :class="isFold5 ? 'el-icon-arrow-up fold_icon' : 'el-icon-arrow-down fold_icon'" @click="isFold5 = !isFold5"></i>
                <span>质检结论</span>
            </div>
            <div :class="{ card_content: 1, case_edit: 1, text_columns: 1 }" v-if="isFold5">
                <el-row class="txt_row">
                    <el-col class="left_col" :span="2">
                        <div class="txtRight card-col_title">是否合格：</div>
                    </el-col>
                    <el-col class="right_col" :span="17" v-if="isEditFlag">
                        <el-select class="width_150" v-model="editForm.qualifiedFlag" placeholder="请选择" size="small" clearable>
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-col>
                    <el-col class="right_col rightBgc" :span="17" v-else>
                        <overflow-txt :txt="caseDetail.caseNo"></overflow-txt>
                    </el-col>
                </el-row>
                <el-row class="txt_row">
                    <el-col class="left_col" :span="2">
                        <div class="txtRight card-col_title">备注：</div>
                    </el-col>
                    <el-col class="right_col" :span="22" v-if="isEditFlag">
                        <el-input v-model="editForm.remarks" type="textarea" :rows="4" maxlength="255" show-word-limit placeholder="请输入内容"></el-input>
                    </el-col>
                    <el-col class="right_col rightBgc" :span="22" v-else>
                        <overflow-txt :txt="editForm.remarks"></overflow-txt>
                    </el-col>
                </el-row>
                <el-button class="submitBtn autoC" type="primary" size="mini" @click="submitFn">提交</el-button>
            </div>
        </div>

        <!-- <el-dialog :visible.sync="showRepeatReport && isEditInfo" center :modal-append-to-body="false" append-to-body :before-close="closeTipsDialog" width="20%">
            <div class="dialog_box risk-dialog">
                <p style="text-align: center; color: #e4393c; font-size: 18px; word-break: break-all; padding: -5px -5px">该案件为重复报案,请谨慎处理!</p>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: -20px">
                <el-button type="primary" @click="closeTipsDialog()">确 定</el-button>
            </div>
        </el-dialog> -->
        <!-- 查看风险 弹窗 -->
        <preview-risk-popup ref="previewRiskPopup" :previewRiskData="previewRiskData" @closeRiskDialog="closeRiskDialog" v-if="previewShow"></preview-risk-popup>
    </div>
</template>
<script>
import PreviewRiskPopup from './toolBox/previewRiskPopup.vue';
export default {
    name: 'caseRisk',
    props: {
        caseDetail: {
            typeof: Object,
            default: {}
        }
    },
    components: {
        PreviewRiskPopup
    },
    data() {
        return {
            activeName: null,
            showPopup: true,
            isEditFlag: true,
            tokenPreviewShow: false,
            previewShow: false,
            isFold1: true,
            isFold2: true,
            isFold3: true,
            isFold3_1: true,
            isFold4: true,
            isFold5: true,
            isFold6: true,
            OSSClient: null,
            liActiveIndex: 0,
            thumbnailActiveIndex: 0,
            riskTitle: '',
            innerVisible: false,
            isEditInfo: false,
            showRepeatReport: false,
            materialTypeForm: {
                code: ''
            },
            imgActiveIndex: 0, // 当前移动图片的索引值
            imgDistance: 0, // 移动的距离
            allDistance: 0, // 总移动距离
            caseRiskVos: [],
            fileTypeList: [],
            caseMaterialsType: [],
            checkedMaterialType: {},
            imgUrlList: [],
            activeNameArray: [],
            riskNumData: {
                num: 0
            },
            previewRiskData: [],
            replacePartsData: [],
            accountTableData: [],
            tableData: [],
            editForm: {
                id: null,
                qualifiedFlag: null,
                remarks: null
            },
            productTypeData: [
                {
                    label: '是',
                    value: true
                },
                { label: '否', value: false }
            ],
            repairList: [],
            replacePartsList: [],
            materialMap: null,
            materialList: [],
            treeData: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    computed: {
        imgStyle() {
            return {
                transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
            };
        }
    },
    methods: {
        goBack() {
            this.$emit('goBack');
        },
        handleRisk() {
            this.caseRiskVos = [];
            if (this.caseDetail.highRiskInfo && this.caseDetail.lowRiskInfo) {
                this.caseRiskVos = [
                    {
                        highCount: this.caseDetail.highRiskInfo.length,
                        highRiskInfos: this.caseDetail.highRiskInfo,
                        // mediumCount:this.caseDetail.mediumRiskInfo.relatedCases.length,
                        lowCount: this.caseDetail.lowRiskInfo.length,
                        lowRiskInfos: this.caseDetail.lowRiskInfo
                    }
                ];
            }
        },
        submitFn() {
            this.$request({ method: 'post', url: '/ubi/api/xinjiang/case/edit', data: this.editForm }).then((res) => {
                if (res.code == 200) {
                    this.$message.success('提交成功！');
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        plateNoClick() {
            // 换件列表tabs
            this.replacePartsList &&
                this.replacePartsList.forEach((item) => {
                    if (item.plateNo == this.activeName) {
                        this.replacePartsData = item.parts;
                    }
                });

            // 外修列表tabs
            this.repairList &&
                this.repairList.forEach((item) => {
                    if (item.plateNo == this.activeName) {
                        this.tableData = item.repairs;
                    }
                });

            // 材料 tree结构
            this.treeData = [];
            if (this.caseDetail.materialMap && this.caseDetail.materialMap[this.activeName]) {
                let tmpMterialMap = this.caseDetail.materialMap[this.activeName];
                this.materialMap = tmpMterialMap;

                for (const key in tmpMterialMap) {
                    let treeChildData = {
                        label: key,
                        children: []
                    };

                    // if (tmpMterialMap[key]) {
                    //     for (const childKey in tmpMterialMap[key]) {
                    //         treeChildData.children.push({ label: childKey });
                    //     }
                    // }

                    this.treeData.push(treeChildData);
                }
            }
        },
        handleNodeClick(data, node) {
            if (!data.label) {
                return;
            }
            // 获取父节点
            const parentNode = node.parent;
            this.materialList = [];
            if (this.materialMap) {
                let tmpMaterialMap = this.materialMap[data.label];

                for (const key in tmpMaterialMap) {
                    this.materialList.push(tmpMaterialMap[key]);
                }

                this.imgUrlList = this.materialList;

                // 切换轮播图
                if (this.imgUrlList.length > 0) {
                    this.switchCarousel(this.materialList[0], 0);
                }
            }
        },
        switchCarousel(data, index) {
            this.imgDistance = 0;
            this.imgActiveIndex = 0;
            this.liActiveIndex = index;
            this.thumbnailActiveIndex = index;
            // if (data.files && data.files.length > 0) {
            //     this.imgUrlList = data.files;
            // }
            // this.imgUrlList = [data.fileUrl];

            this.imgUrlList = data;
        },
        openCase(caseNo) {
            const routeUrl = this.$router.resolve({
                path: '/caseInquiry/index',
                query: { caseNo: caseNo, query: 'query' }
            });
            window.open(routeUrl.href, '_blank');
        },
        imgLeft() {
            if (this.imgActiveIndex > 0) {
                this.imgActiveIndex--; // 索引值-1
            }
            if (this.imgActiveIndex >= 4) {
                var index = 0;
                const temp = window.setInterval(() => {
                    // 利用定时器实现图片左右移动的动画效果
                    if (index < 33) {
                        // 移动次数(33次)
                        this.imgDistance += 2; // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
                        index++;
                        return;
                    } else {
                        window.clearInterval(temp); // 移动完清除定时器
                    }
                }, 10);
            }
        },
        imgRight() {
            if (this.imgActiveIndex < this.imgUrlList.length - 1) {
                this.allDistance = 0;
                this.imgActiveIndex++;
                if (this.imgActiveIndex >= 5) {
                    this.allDistance = -66 * (this.imgActiveIndex - 4);
                    var index = 0;
                    const temp = window.setInterval(() => {
                        if (index < 33) {
                            this.imgDistance -= 2; // 每次向右移动的距离
                            index++;
                            return;
                        } else {
                            window.clearInterval(temp);
                        }
                    }, 10);
                }
            } else if (this.imgActiveIndex === this.imgUrlList.length - 1) {
                // 到达最后一张图片，再点击跳转回第一张
                this.imgActiveIndex = 0;
                var index = 0;
                const temp = window.setInterval(() => {
                    // 利用定时器实现图片左右移动的动画效果
                    if (index < Math.abs(this.allDistance / 2)) {
                        // 取绝对值再除
                        this.imgDistance += 2; // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
                        index++;
                        return;
                    } else {
                        window.clearInterval(temp); // 移动完清除定时器
                    }
                }, 1);
            }
        },

        // 关闭重复案件提示框
        closeTipsDialog() {
            this.showRepeatReport = false;
        },
        //获取所有的材料类型
        getFileTypeList() {
            this.instance.get('/tpa/api/enum/getCaseMaterialsTypeEnum', {}).then((res) => {
                if (res.data.code === 200) {
                    let data = res.data.data;
                    let arr = [];
                    data.forEach((value) => {
                        value.remark = '';
                        value.enumList.forEach((val) => {
                            value.remark += val.desc + '、';
                        });
                        value.remark && (value.remark = '所有' + value.remark.slice(0, -1));
                        arr = arr.concat(value.enumList);
                    });
                    this.caseMaterialsType = data;
                    this.fileTypeList = arr;
                }
            });
        },
        //点击修改材料类型按钮
        handleEditType(item, par) {
            this[par] = true;
            this.checkedMaterialType = item ? item : null;
            this.titleMaterialType = item ? '修改材料类型' : '选择材料类型';
            this.materialTypeForm = item ? this.materialTypeForm : { code: '' };
        },
        initImgUrlAll() {
            this.previewRiskData = null;
            this.tokenPreviewShow = false;

            if (this.caseDetail && this.caseDetail.caseRiskVos) {
                let tmpCaseRiskVos = this.caseDetail.caseRiskVos;

                if (this.OSSClient) {
                    tmpCaseRiskVos.forEach((res) => {
                        // 通过oss换取imgurl
                        res.highRiskInfos && this.tradeImgUrl(res.highRiskInfos);
                        res.mediumRiskInfos && this.tradeImgUrl(res.mediumRiskInfos);
                        res.lowRiskInfos && this.tradeImgUrl(res.lowRiskInfos);
                        this.$forceUpdate();
                    });
                    this.previewRiskData = tmpCaseRiskVos;
                    this.tokenPreviewShow = true;
                    if (this.tmpPreviewData) {
                        this.$refs.previewRiskPopup && this.$refs.previewRiskPopup.switchRiskImg(this.tmpPreviewData.riskCardList, this.tmpPreviewData.currentRiskItem, this.tmpPreviewData.currentRiskIndex, this.tmpPreviewData.riskCardIndex);
                    }
                    this.$forceUpdate();
                    this.tmpPreviewData = null;
                } else {
                    setTimeout(() => {
                        this.initImgUrlAll();
                    }, 500);
                }
            }
        },
        tradeImgUrl(tmpImgList) {
            tmpImgList.forEach((item) => {
                if (item.imageList) {
                    item.imageList.forEach((imgItem) => {
                        let imgType = ['.bmp', '.dib', '.pcp', '.dif', '.wmf', '.gif', '.jpg', '.tif', '.eps', '.psd', '.cdr', '.iff', '.tga', '.pcd', '.mpt', '.png', '.jpeg', '.psd', '.svg', '.ufo', '.dng', '.tga', '.eps', '.pcx', '.cdr'];

                        imgItem.url = imgItem.materialPath ? this.OSSClient.signatureUrl(imgItem.materialPath) : imgItem.materialOriginalPath;

                        // 判断图片类型
                        let tmpUrlArr = imgItem.url.split('?');
                        tmpUrlArr = tmpUrlArr[0];
                        let tmpLastIndex = tmpUrlArr.lastIndexOf('.');
                        let suffix = tmpLastIndex != -1 ? tmpUrlArr.slice(tmpLastIndex, tmpUrlArr.length).toLowerCase() : -1;
                        if (suffix.length > 6 && suffix.indexOf('%') != -1) {
                            let tmpSuffix = suffix.split('%')[0];
                            suffix = tmpSuffix ? (tmpSuffix == '.com' ? true : false) : '未识别';
                        }

                        // 图片后缀

                        imgItem.isImg = Boolean(suffix != -1);
                        imgItem.suffix = suffix;
                        this.$forceUpdate();
                    });
                }
            });
        },
        showRiskPreviewDialog(riskCardIndex, riskCardList, currentRiskItem, currentRiskIndex) {
            this.previewShow = true;
            this.tmpPreviewData = {
                riskCardIndex: riskCardIndex,
                riskCardList: riskCardList,
                currentRiskItem: currentRiskItem,
                currentRiskIndex: currentRiskIndex
            };
            this.$nextTick(() => {
                this.$refs.previewRiskPopup && this.$refs.previewRiskPopup.switchRiskImg(riskCardList, currentRiskItem, currentRiskIndex, riskCardIndex);
            });
        },
        closeRiskDialog(flag) {
            this.previewShow = flag;
        }
    },
    watch: {
        caseDetail: {
            handler(val) {
                if (val && val.caseNo) {
                    let tmpPlateNos = [];

                    // 换件
                    if (val.replacePartsList && val.replacePartsList.length > 0) {
                        this.replacePartsList = val.replacePartsList;
                    } else {
                        this.replacePartsList = [];
                    }

                    // 外修
                    if (val.repairList && val.repairList.length > 0) {
                        this.repairList = val.repairList;
                        this.activeName = this.repairList[0].plateNo;
                        val.repairList.forEach((item) => {
                            tmpPlateNos.push(item.plateNo);
                        });
                    } else {
                        this.repairList = [];
                    }

                    // 账户
                    if (val.paymentList && val.paymentList.length > 0) {
                        this.accountTableData = val.paymentList;
                    } else {
                        this.accountTableData = [];
                    }

                    // 补偿：案件材料车牌号存在，但是外修列表不存在这个车牌号
                    let tmpMaterialMap = val.materialMap;
                    if (Object.keys(tmpMaterialMap).length > 0) {
                        for (const key in tmpMaterialMap) {
                            if (tmpPlateNos.indexOf(key) < 0) {
                                this.repairList.push({
                                    plateNo: key,
                                    repairs: []
                                });
                            }
                        }
                    }

                    this.handleRisk();
                    this.plateNoClick();
                }
            },
            immediate: true
        }
    }
};
</script>
<style scoped lang="less">
// @import '../../assets/css/public.css';
@import '../../assets/css/caseCard.css';
.case_card {
    padding: 0 !important;
    background: none !important;
}
.cardBgc {
    background: #fff;
    padding: 30px 20px;
}
.caseInfo {
    margin-bottom: 20px;
    padding-top: 40px;
    .btnGroups {
        // position: fixed;
        // top: 70px;
        // z-index: 9;
        position: relative;
        margin-bottom: 10px;
        .el-button {
            position: absolute;
            top: -30px;
            right: 0px;
        }
    }
}
.casePlateNo {
    margin-bottom: 20px;
    padding-top: 10px;
    .noneMarginTop {
        margin-top: 0 !important;
    }
    .card_content {
        .el-row {
            margin-bottom: 10px;
        }
    }
}

.caseBottom {
    padding-top: 10px;
}
.card_content .el-collapse-item__wrap {
    border-bottom: 0 !important;
}
.risk-card_img {
    position: relative;
    width: 143px;
    height: 128px;
}
.img_none {
    margin-top: 20px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background: transparent;
    box-shadow: none;
    border: none;
    top: 23%;
}
.dialog_box {
    .repeat {
        color: #005bab;
        cursor: pointer;
    }
}

.materialBox {
    .material_left {
        width: 18%;
        min-width: 200px;
        // border: 1px solid red;
    }
    .material_right {
        // border: 1px solid blue;
        width: 80%;
    }
}

.submitBtn {
    margin-top: 80px;
}
</style>
<style lang="less">
/deep/ .el-image-viewer__wrapper {
    border: 1px solid red;
}
</style>